import { http } from './config';

let authData = {};

if (localStorage.getItem('vibbra-user') != null) {
  authData = JSON.parse(localStorage.getItem('vibbra-user'));

  http.defaults.headers.common['access-token'] = authData.access_token;
  http.defaults.headers.common.client = authData.client_code;
  http.defaults.headers.common.expiry = authData.expiry;
  http.defaults.headers.common['token-type'] = 'Bearer';
  http.defaults.headers.common.uid = authData.uid;
}

export default {
  sign_in: (email, password) =>
    http.post('client/auth/sign_in', { email, password }),
  sign_up: (
    email,
    password,
    password_confirmation,
    name,
    lastname,
    accepted_term,
    cel_phone,
    position,
    area,
    site
  ) =>
    http.post('client/auth', {
      email,
      password,
      password_confirmation,
      name,
      lastname,
      accepted_term,
      confirm_success_url: process.env.BASE_URL + 'client/login',
      cel_phone,
      position,
      area,
      site
    }),
  sign_out: () =>
    http({
      method: 'delete',
      url: 'client/auth/sign_out',
    }),
  revoveryPass: email =>
    http({
      method: 'post',
      url: 'client/auth/password',
      data: {
        email,
        redirect_url: process.env.BASE_URL + 'client/new-pass',
      },
    }),
  updatePass: (password, password_confirmation, headers) =>
    http({
      method: 'PUT',
      url: 'client/auth/password',
      data: {
        password,
        password_confirmation,
      },
      headers,
    }),
  getClientData: () =>
    http({
      method: 'get',
      url: 'client/users/0',
    }),
  updateProfile: client =>
    http({
      method: 'put',
      url: 'client/users/0',
      data: { client },
    }),
  updateCompany: company =>
    http({
      method: 'put',
      url: 'client/client_companies/' + company.id,
      data: { client_company: company },
    }),
  searchVibbrantes: params =>
    http({
      method: 'post',
      url: 'client/search',
      data: {
        filter: params,
      },
    }),
  searchCustomVibbrantes: params =>
      http({
        method: 'post',
        url: 'client/search_custom',
        data: {
          ...params
        },
      }),
  acceptTerms: () =>
    http({
      method: 'post',
      url: 'client/accept_terms',
      data: { },
    }),
  sendInvitationToVibbrantes: selected_vibbrantes => {
    const requestContracts = [];
    for (let i = 0; i < selected_vibbrantes.length; i++) {
      console.log(selected_vibbrantes[i]);
      requestContracts.push({
        vibbrante_id: selected_vibbrantes[i].id,
        expect_hours: selected_vibbrantes[i].expect_hours,
        description: selected_vibbrantes[i].invation_description,
        expected_hour_value: selected_vibbrantes[i].hour_value,
        hours_undefined: selected_vibbrantes[i].hours_undefined,
      });
    }
    return http({
      method: 'post',
      url: 'client/contracts',
      data: {
        request_contracts: requestContracts,
      },
    });
  },
  loadPendingContracts: () =>
    http({
      method: 'get',
      url: 'client/contracts/pending',
    }),
  loadActivesContracts: () =>
    http({
      method: 'get',
      url: 'client/contracts/actives',
      timeout: 9999999
    }),
  loadAbleToCreditContracts: () =>
    http({
      method: 'get',
      url: 'client/contracts/able_to_credit',
    }),
  loadClosedContracts: currentPage =>
    http({
      method: 'get',
      url: 'client/contracts/closed?page=' + (currentPage || 1),
    }),
  clientCloseByReject: contract_id =>
    http({
      method: 'put',
      url: 'client/contracts/' + contract_id,
      data: {
        contract: {
          id: contract_id,
          status: 'close_by_reject',
        },
      },
    }),
  clientRatingContract: contract =>
    http({
      method: 'put',
      url: 'client/contracts/' + contract.id,
      data: {
        contract: {
          rating: contract.rating,
          rating_quality: contract.rating_quality,
          rating_professionalism: contract.rating_professionalism,
          rating_recommendation: contract.rating_recommendation,
          rating_comment: contract.rating_comment,
        },
      },
    }),
  clientActivedContract: (contract_id, pj_or_pf) =>
    http({
      method: 'put',
      url: 'client/contracts/' + contract_id,
      data: {
        contract: {
          id: contract_id,
          status: 'waiting_credit',
          pj_or_pf,
        },
      },
    }),
  clientCreateContractAdditive: (contract_id, hours) =>
    http({
      method: 'post',
      url: 'client/contracts/' + contract_id + '/contract_additive',
      data: {
        contract_additive: {
          hours,
        },
      },
    }),
  clientGetContract: contract_id =>
    http({
      method: 'get',
      url: 'client/contracts/' + contract_id,
      timeout: 99999,
    }),
  clientGetContractModels: contract_id =>
    http({
      method: 'get',
      url: 'client/contracts/' + contract_id + '/contract_models',
    }),
  clientGetSignedContract: contract_id =>
    http({
      method: 'get',
      url: 'client/contracts/' + contract_id + '/signed_contract',
    }),
  clientRejectContract: (contract_id, reject_text, cancellation_reason_id) =>
    http({
      method: 'put',
      url: 'client/contracts/' + contract_id,
      data: {
        contract: {
          id: contract_id,
          reject_description: reject_text,
          status: 'reject_by_client',
          cancellation_reason_id,
        },
      },
    }),
  buyContractCredits: contracts =>
    http({
      method: 'post',
      url: 'client/contract_credits',
      data: {
        credits: contracts,
      },
    }),
  clientExtract: month =>
    http({
      method: 'get',
      url: 'client/wallet/extract?month=' + month,
    }),
  clientBalances: () =>
    http({
      method: 'get',
      url: 'client/wallet/balances',
    }),
  clientTaskComment: task_id =>
    http({
      method: 'get',
      url: 'client/tasks/' + task_id + '/comments',
    }),
  clientCreateTaskComment: (task_id, description) =>
    http({
      method: 'post',
      url: 'client/tasks/' + task_id + '/comment',
      data: {
        task_comment: {
          description,
        },
      },
    }),
  clientResolvedTask: task_id =>
    http({
      method: 'put',
      url: 'client/tasks/' + task_id + '/resolved/',
    }),
  clientContractComment: contract_id =>
    http({
      method: 'get',
      url: 'client/contracts/' + contract_id + '/comments',
    }),
  clientContractCommentToRead: contract_id =>
    http({
      method: 'put',
      url: 'client/contracts/' + contract_id + '/mark_comments_read',
    }),
  clientCreateContractComment: (contract_id, description) =>
    http({
      method: 'post',
      url: 'client/contracts/' + contract_id + '/comment',
      data: {
        contract_comment: {
          description,
        },
      },
    }),
  clientLoadSkills: () =>
    http({
      method: 'get',
      url: 'client/list/skills',
    }),
  clientLoadSubjects: () =>
    http({
      method: 'get',
      url: 'client/list/subjects',
    }),
  clientNotifications: () =>
    http({
      method: 'get',
      url: 'client/notifications',
    }),
  clientSearchOptions: () =>
    http({
      method: 'get',
      url: 'client/options_list',
    }),
  clientCreateHelpMessage: (subject_id, body) =>
    http({
      method: 'post',
      url: 'client/help_messages',
      data: {
        help_message: {
          help_subject_id: subject_id,
          body_message: body,
        },
      },
    }),
  clientPaySprint: (contract_id, contract_debit_id) =>
    http({
      method: 'put',
      url:
        'client/contracts/' + contract_id + '/pay_sprint/' + contract_debit_id,
    }),
  clientSetNotificationRead: notification_id =>
    http({
      method: 'put',
      url: 'client/notifications/' + notification_id,
      data: {
        notification: {
          read: true,
        },
      },
    }),
  clientLoadCancellationReasons: () =>
    http({
      method: 'get',
      url: 'client/cancellation_reasons',
    }),
  clientGetVibbranteContract: vibbrante_id =>
    http({
      method: 'get',
      url: 'client/contracts/' + vibbrante_id + '/vibbrante',
    }),
  getTasks: (contract_id, start_date, end_date) =>
    http({
      method: 'get',
      url: `client/contracts/${contract_id}/tasks?start_date=${start_date}&end_date=${end_date}`,
    }),
  clientLoadVibbrante: vibbrante_id =>
    http({
      method: 'get',
      url: 'client/vibbrante_profile/' + vibbrante_id,
    }),
  clientAcceptTerm: () =>
    http({
      method: 'put',
      url: 'client/users/0',
      data: {
        client: {
          accepted_term: true,
        },
      },
    }),
  clientReleaseAccess: client =>
    http({
      method: 'post',
      url: 'client/users/release_register',
      data: {
        client,
      },
    }),
  contractCreditTransfer: contract_transfer =>
    http({
      method: 'post',
      url: 'client/contract_transfers',
      data: {
        contract_transfer,
      },
    }),
};



// WEBPACK FOOTER //
// ./src/api/client.js